import { render, staticRenderFns } from "./ModuleAccessWalletHardware.vue?vue&type=template&id=7518921a&scoped=true&"
import script from "./ModuleAccessWalletHardware.vue?vue&type=script&lang=js&"
export * from "./ModuleAccessWalletHardware.vue?vue&type=script&lang=js&"
import style0 from "./ModuleAccessWalletHardware.vue?vue&type=style&index=0&id=7518921a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7518921a",
  null
  
)

export default component.exports